import ListDeliveries from '../../UI/Deliveries/ListDeliveries';
import { useParams } from 'react-router';
import { LegacyCard, Page } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { getDepositById } from '../../../services/depositsService';

const Deliveries = () => {
  const { page } = useParams();
  const [deposit, setDeposit] = useState(null);

  const returnMatch = window.location.search.match(/\??r=(.+)&?/);
  const returnUrl = returnMatch && returnMatch.length > 1 ? window.atob(returnMatch[1]) : null;

  const depositId = window.location.search.match(/\??depositId=(.+)&?/)
    ? window.location.search.match(/\??depositId=(.+)&?/)[1]
    : null;

  useEffect(() => {
    if (depositId) {
      getDepositById(depositId).then((r) => {
        setDeposit(r.data);
      });
    }
  }, [depositId]);

  return <>
    <Page
      title="Recepcion de mercancía"
      subtitle={deposit ? deposit.name : 'Todas las recepciones'}
      divider
      backAction={{ content: 'Volver', url: returnUrl }}
    >
      <LegacyCard>
        <ListDeliveries page={page || 1} depositId={depositId} />
      </LegacyCard>
    </Page>
  </>;
};

export default Deliveries;
